import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AttachmentNameCell } from './AttachmentNameCell';
import { toBuildingAttachmentRow } from '../utils/toBuildingAttachmentRow';
const BUILDING_ID = 42;
const identityTranslate = (key) => key;
function withRow(apiRow) {
    return function Story() {
        const client = useMemo(() => new QueryClient({ defaultOptions: { queries: { retry: false } } }), []);
        const item = toBuildingAttachmentRow(apiRow, identityTranslate);
        return (React.createElement(QueryClientProvider, { client: client },
            React.createElement(AttachmentNameCell, { item: item, buildingId: BUILDING_ID })));
    };
}
const meta = {
    title: 'Features/BuildingAttachments/AttachmentNameCell',
    tags: ['autodocs'],
    parameters: { layout: 'padded' }
};
export default meta;
/** Click to edit the basename inline; the extension stays static text (E2E-27). */
export const WithExtension = {
    render: withRow({
        id: 1,
        name: '2026-alarm-inspection-report.pdf',
        attachmentCategoryId: 1,
        categoryName: 'Reports',
        createdAt: '2026-09-15T14:30:00-04:00',
        fileSize: 655360,
        isPrivate: false,
        showOnCustomerPortal: true,
        url: 'https://cdn.example.com/reports/2026-alarm-inspection-report.pdf'
    })
};
/** A name with no recognized extension is entirely editable. */
export const WithoutExtension = {
    render: withRow({
        id: 2,
        name: 'README',
        attachmentCategoryId: null,
        categoryName: null,
        createdAt: '2026-09-15T14:30:00-04:00',
        fileSize: 1024,
        isPrivate: false,
        showOnCustomerPortal: false,
        url: 'https://cdn.example.com/misc/README'
    })
};
